<template>
    <div :class="['ufo--page-sections', { 'sidebar-layout': isSidebarHeroLayout }]">
        <template v-if="isSidebarHeroLayout">
            <div :id="`section-${portfolioHeroSection._id}`" class="sidebar-rail">
                <PortfolioSidebarHeroSection
                    :section="portfolioHeroSection"
                    :navigation="portfolioNavigationSection"
                    :navigation-visibility="navigationVisibility"
                />
            </div>
            <div class="sidebar-content">
                <div v-if="navigationVisibility.showOutside" class="section-container">
                    <PortfolioNavigationSection
                        :id="`section-${portfolioNavigationSection._id}`"
                        :section="portfolioNavigationSection"
                    />
                </div>
                <div class="section-container" v-bind:key="section._id" v-for="(section, index) in filteredSection"  @mouseenter="hover = index" @mouseleave="hover = null">
                    <FabWrapper v-if="isReviewModeActive && $reviewStore.review" :invertedIndex="(filteredSection.length - index + 2)" :hovering="hover === index" :section="section"/>
                    <component
                        :is="getSection(section)"
                        :id="`section-${section._id}`"
                        :data-section-index="`section-${section.index}`"
                        :section="section"
                        :style="[getSpacing(section)]"
                    />
                </div>
                <div class="section-container" v-if="isRelatedFooterEnabled" @mouseenter="hover = relatedFooterIndex" @mouseleave="hover = null">
                    <FabWrapper v-if="isReviewModeActive && $reviewStore.review" :invertedIndex="3" :hovering="hover === relatedFooterIndex" :section="{_id:'related-footer'}" />
                    <RelatedCaseStudiesSection />
                </div>
                <div class="section-container" v-if="isPortfolioFooterEnabled" @mouseenter="hover = footerIndex" @mouseleave="hover = null">
                    <FabWrapper v-if="isReviewModeActive && $reviewStore.review" :invertedIndex="2" :hovering="hover === footerIndex" :section="{_id:'footer'}" />
                    <PortfolioFooterSection />
                </div>
                <LegacyPageFooter v-if="showLegacyPageFooter" />
                <div v-if="showCaseStudyProjectFooter" class="project-footer">
                    <LegacyCaseStudyFooter />
                    <UXfolioBranding v-if="user.accountSettings.folioLogo" class="footer-share" :class="portfolio.templateSettings.theme !== 'profile_theme_nine' ? 'show-color-background' : ''" />
                </div>
            </div>
        </template>
        <template v-else>
            <HeaderSections
                :show-portfolio-hero="showPortfolioHero"
                :portfolio-hero-section="portfolioHeroSection"
                :portfolio-navigation-section="portfolioNavigationSection"
                :navigation-visibility="navigationVisibility"
                :is-sidebar-hero-layout="isSidebarHeroLayout"
            />

            <div class="section-container" v-bind:key="section._id" v-for="(section, index) in filteredSection"  @mouseenter="hover = index" @mouseleave="hover = null">
                <FabWrapper v-if="isReviewModeActive && $reviewStore.review" :invertedIndex="(filteredSection.length - index + 2)" :hovering="hover === index" :section="section"/>
                <component
                    :is="getSection(section)"
                    :id="`section-${section._id}`"
                    :data-section-index="`section-${section.index}`"
                    :section="section"
                    :style="[getSpacing(section)]"
                />
            </div>
            <div class="section-container" v-if="isRelatedFooterEnabled" @mouseenter="hover = relatedFooterIndex" @mouseleave="hover = null">
                <FabWrapper v-if="isReviewModeActive && $reviewStore.review" :invertedIndex="3" :hovering="hover === relatedFooterIndex" :section="{_id:'related-footer'}" />
                <RelatedCaseStudiesSection />
            </div>
            <div class="section-container" v-if="isPortfolioFooterEnabled" @mouseenter="hover = footerIndex" @mouseleave="hover = null">
                <FabWrapper v-if="isReviewModeActive && $reviewStore.review" :invertedIndex="2" :hovering="hover === footerIndex" :section="{_id:'footer'}" />
                <PortfolioFooterSection />
            </div>
            <LegacyPageFooter v-if="showLegacyPageFooter" />
            <div v-if="showCaseStudyProjectFooter" class="project-footer">
                <LegacyCaseStudyFooter />
                <UXfolioBranding v-if="user.accountSettings.folioLogo" class="footer-share" :class="portfolio.templateSettings.theme !== 'profile_theme_nine' ? 'show-color-background' : ''" />
            </div>
        </template>
    </div>
</template>

<script>
import GeneralSection from "./GeneralSection.vue";
import Columns from "./Columns.vue";
import MainHeader from "./MainHeader.vue";
import Stat from "./Stats.vue";
import Gallery from "./Gallery.vue";
import Tabs from "./Tabs.vue";
import ProjectGrid from "./ProjectGrid.vue";
import Testimonial from "./Testimonial.vue";
import LogoWall from "./LogoWall.vue";
import Process from "./Process.vue";
import DividerLine from "./DividerLine.vue";
import AnimatedText from "./AnimatedText.vue";
import PortfolioNavigationSection from "./PortfolioNavigationSection.vue";
import Cards from "./Cards.vue";
import PortfolioFooterSection from "./PortfolioFooterSection.vue";
import RelatedCaseStudiesSection from "@/scripts/view/portfolio/sections/RelatedCaseStudiesSection.vue";
import LegacyCaseStudyFooter from "@/scripts/view/portfolio/common/LegacyCaseStudyFooter.vue";
import LegacyPageFooter from "@/scripts/view/portfolio/common/LegacyPageFooter.vue";
import UXfolioBranding from "@/scripts/view/portfolio/common/UXfolioBranding.vue";
import FabWrapper from "../../review/components/FabWrapper.vue";
import HeaderSections from "@/scripts/view/portfolio/sections/common/HeaderSections.vue";
import PortfolioSidebarHeroSection from "@/scripts/view/portfolio/sections/PortfolioSidebarHeroSection.vue";
import {mapGetters} from "vuex";
import { getPortfolioNavigationVisibility } from "@/scripts/sections/common/navigation/navigationPlacementHelper.js";
import {
    GeneralSectionTypeEnum,
    NavigationPlacementEnum,
    PageTypesEnum,
    SectionTypesEnum
} from "@/scripts/common/enums.js";
import { getRelatedCaseStudies } from "@/scripts/common/utilities/sectionHelpers.js";

export default {
    name: "SectionLoader",
    components: {
        Columns,
        GeneralSection,
        FabWrapper,
        LegacyCaseStudyFooter,
        LegacyPageFooter,
        PortfolioFooterSection,
        RelatedCaseStudiesSection,
        UXfolioBranding,
        MainHeader,
        Stat,
        Gallery,
        Tabs,
        ProjectGrid,
        Testimonial,
        LogoWall,
        Process,
        DividerLine,
        AnimatedText,
        PortfolioNavigationSection,
        HeaderSections,
        PortfolioSidebarHeroSection,
        Cards
    },
    props: ['sections', 'defaultImageAlt'],
    data() {
        return {
            hover: null
        }
    },
    methods: {
        getSection(section) {
            const generalSectionSet = new Set(Object.values(GeneralSectionTypeEnum));

            let sectionComponent = section.type

            if( generalSectionSet.has(section.type) ) {
                sectionComponent = 'GeneralSection'
            }
            if (section.type === SectionTypesEnum.PROCESS) {
                sectionComponent = 'Process'
            }

            return sectionComponent;
        },
        getSpacing(section) {
            if(this.project.settings && this.project.settings.globalSpacingEnabled) {
                if(this.project.settings.globalSpacing) {
                    return {
                        '--section-padding-top': this.project.settings.globalSpacing + 'px',
                        '--section-padding-bottom': this.project.settings.globalSpacing + 'px'
                    }
                }
                else {
                    return {
                        '--section-padding-top': '0px',
                        '--section-padding-bottom': '0px'
                    }
                }
            }
            else {
                let style = {};
                if(section.styleSettings) {
                    if(section.styleSettings.paddingTop !== null) {
                        style['--section-padding-top'] = section.styleSettings.paddingTop + 'px'
                    }

                    if(section.styleSettings.paddingBottom !== null) {
                        style['--section-padding-bottom'] = section.styleSettings.paddingBottom + 'px'

                    }
                }
                return style
            }
        }
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        project() {
            return this.viewData.project;
        },
        portfolio() {
            return this.viewData.portfolio;
        },
        user() {
            return this.viewData.user;
        },
        portfolioHeroSection() {
            return this.portfolio?.portfolioHero || null;
        },
        portfolioHasNavigationSection() {
            if (!this.portfolio?.portfolioNavigation) return false;
            const isCaseStudy = this.project?.type === PageTypesEnum.CASE_STUDY;
            return !isCaseStudy
                || this.isSidebarHeroLayout
                || !!this.portfolio?.settings?.showNavOnCollectionItems;
        },
        portfolioNavigationSection() {
            if (!this.portfolioHasNavigationSection) return null;
            return this.portfolio?.portfolioNavigation || null;
        },
        showPortfolioHero() {
            if (!this.portfolioHeroSection) return false;
            if (this.isSidebarHeroLayout) return true;
            if (this.project?.type === PageTypesEnum.CASE_STUDY) return false;
            if (this.project?.type === PageTypesEnum.HOME) return true;
            return this.portfolioNavigationSection?.layout?.position === NavigationPlacementEnum.BOTTOM;
        },
        navigationVisibility() {
            return getPortfolioNavigationVisibility({
                navigation: this.portfolioNavigationSection,
                isSidebarHeroLayout: this.isSidebarHeroLayout,
                isCaseStudy: this.project?.type === PageTypesEnum.CASE_STUDY,
            });
        },
        isSidebarHeroLayout() {
            return this.$store.getters.heroIsSidebar;
        },
        isReviewModeActive() {
            return this.$reviewStore.isReviewMode;
        },
        footerDisabledInThemes() {
            return ['theme_four', 'profile_theme_four', 'theme_nine', 'profile_theme_nine', 'theme_default', 'profile_theme_default']
        },
        footerIndex() {
            return this.sections.length + 1
        },
        relatedFooterIndex() {
            return this.sections.length + 2
        },
        portfolioTemplate() {
            return this.portfolio.templateSettings.theme.replace("_old", "");
        },
        isRelatedFooterEnabled() {
            const isCaseStudy = this.project.type === 'caseStudy';
            return isCaseStudy
                && !!this.portfolio.settings?.showRelatedCaseStudiesOnProjects
                && this.relatedFooterProjects.length > 0;
        },
        isPortfolioFooterEnabled() {
            const isCaseStudy = this.project.type === 'caseStudy';
            if (isCaseStudy) {
                return this.portfolio.settings.showFooterOnProjects && this.portfolio.portfolioFooter;
            }
            return (
                this.portfolio.settings.showFooterOnPortfolio &&
                !this.footerDisabledInThemes.includes(this.portfolioTemplate) &&
                this.portfolio.portfolioFooter
            );
        },
        showCaseStudyProjectFooter() {
            return this.project.type === 'caseStudy' && !this.iframeUrl;
        },
        showLegacyPageFooter() {
            return this.project.type !== 'caseStudy' && this.portfolio.settings.showFooterOnPortfolio === null;
        },
        iframeUrl() {
            return window.location.pathname.includes('/uxs-headless/\'')
        },
        filteredSection() {
            return this.sections.filter(section => !section.deletedAt);
        },
        relatedFooterProjects() {
            return getRelatedCaseStudies({
                caseStudies: this.viewData.caseStudies || [],
                currentId: this.viewData.activePage
            });
        }
    }
}
</script>

<style scoped lang="scss">
    //For sticky review buttons
    .section-container {
        position: relative;
    }
</style>
